import React from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    textField: {
        paddingTop: 0,
        marginTop: 0,
        marginBottom: 0,
    },
}));

const TextFilter = ({ onChange, onSubmit, value }) => {
    const classes = useStyles();
    const handleChange = event => {
        onChange(event.target.value);
    };

    return (
        <TextField
            label="Value"
            autoFocus
            className={classes.textField}
            onChange={handleChange}
            onKeyPress={ev => {
                if (ev.key === 'Enter') {
                    ev.preventDefault();
                    onSubmit();
                }
            }}
            value={value}
            margin="normal"
        />
    );
};

export { TextFilter };
